"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PRODUCTS_TOTAL_COUNT_BY_FILTER = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_PRODUCTS_TOTAL_COUNT_BY_FILTER = (0, gql_1.gql)(`
  query ProductsTotalCountByFilter(
    $catalogId: ID!
    $productTreeNodeId: ID!
    $filter: ProductPresentationFilter
  ) {
    productTreeNode(id: $productTreeNodeId) {
      id
      productPresentationsNew(
        catalog: $catalogId
        filter: $filter
        first: 0
      ) {
        totalCount
      }
    }
  }
`);
